module.exports = __webpack_public_path__ + "img/ic_contentitem_empty.15806a92.svg";